import { useContext, useMemo, useState } from 'react';

import { RoutesContext } from '@confluence/route-manager';

import { WhiteboardNavigationService } from './services/whiteboard-navigation-service';

export const useNavigationService = (spaceKey: string) => {
	const { push } = useContext(RoutesContext);
	const [navigationService] = useState(() => new WhiteboardNavigationService());

	useMemo(() => {
		navigationService.setPushFn(push);
		navigationService.setSpaceKey(spaceKey);
	}, [navigationService, push, spaceKey]);

	return navigationService;
};
